import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, FileCheck, ScanFace } from 'lucide-react';
const BADGES = [{
  label: 'PCI-DSS',
  sub: 'Level 1'
}, {
  label: 'POPIA',
  sub: 'Compliant'
}, {
  label: 'FSCA',
  sub: 'Aligned'
}, {
  label: 'ISO 27001',
  sub: 'Certified'
}];
const PILLARS = [{
  icon: <ScanFace className="w-5 h-5" data-id="element-372" />,
  title: 'No OTP architecture',
  desc: 'Customers authorise from their bank app, never by typing a code on USSD. Phishing surface drops to zero.'
}, {
  icon: <Lock className="w-5 h-5" data-id="element-373" />,
  title: 'SIM-swap detection',
  desc: 'Live MNO checks block transactions on recently ported numbers. Built into every request.'
}, {
  icon: <FileCheck className="w-5 h-5" data-id="element-374" />,
  title: 'Audit-ready logs',
  desc: 'Every event signed, timestamped, and exportable. Pass internal audit and the regulator first time.'
}];
export function Safety() {
  return <section id="security" className="py-24 bg-ink-2 border-y border-white/5" data-id="element-375">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-376">
        <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-377">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-378">
            
            <div className="text-xs font-medium uppercase tracking-[0.2em] text-mint mb-4" data-id="element-379">
              Security & compliance
            </div>
            <h2 className="display text-bone mb-6" style={{
            fontSize: 'clamp(2.25rem, 5vw, 4rem)'
          }} data-id="element-380">
              
              Audit-grade by{' '}
              <span className="display-italic text-mint" data-id="element-381">default</span>.
            </h2>
            <p className="text-lg text-bone-dim mb-10 leading-relaxed" data-id="element-382">
              Built from the ground up for South African financial regulation.
              Your risk, compliance, and audit teams will sleep better.
            </p>

            <div className="grid grid-cols-2 gap-3" data-id="element-383">
              {BADGES.map(b => <div key={b.label} className="bg-ink rounded-2xl p-5 border border-white/5 flex items-center gap-3" data-id="element-384">
                
                  <ShieldCheck className="w-8 h-8 text-mint flex-shrink-0" data-id="element-385" />
                  <div data-id="element-386">
                    <div className="font-semibold text-bone" data-id="element-387">{b.label}</div>
                    <div className="text-xs text-muted" data-id="element-388">{b.sub}</div>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3" data-id="element-389">
            
            {PILLARS.map((p, i) => <div key={i} className="bg-ink rounded-3xl p-6 border border-white/5 flex gap-5 hover:border-mint/30 transition-colors" data-id="element-390">
              
                <div className="w-12 h-12 rounded-2xl bg-mint-soft text-mint flex items-center justify-center flex-shrink-0" data-id="element-391">
                  {p.icon}
                </div>
                <div data-id="element-392">
                  <h3 className="text-xl font-semibold text-bone mb-2 tracking-tight" data-id="element-393">
                    {p.title}
                  </h3>
                  <p className="text-base text-bone-dim leading-relaxed" data-id="element-394">
                    {p.desc}
                  </p>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}